import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { User } from "src/app/shared/models/user/user.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
var CompanyPlatformNotesDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function CompanyPlatformNotesDialogComponent(dialogRef, data, configService, cookieService, translateService, authService, apiService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.authService = authService;
        this.apiService = apiService;
        this.subscriptions = [];
        this.user = new User();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.confirm"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: true,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true
            }
        };
        // END - Add subUser form
        this.dialogIsLoading = true;
        this.title = "";
        this.text = "";
        this.notes = [];
        this.selectAll = false;
        dialogRef.disableClose = true;
    }
    /**
     * Init component
     *
     */
    CompanyPlatformNotesDialogComponent.prototype.ngOnInit = function () {
        var e_1, _a;
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        this.title = this.translateService.instant("properties.dialog.companyPlatformNotes.title");
        this.text = this.translateService.instant("properties.dialog.companyPlatformNotes.text");
        if (this.data) {
            if (this.data.title && this.data.title !== '') {
                this.title = this.data.title;
            }
            if (this.data.text && this.data.text !== '') {
                this.text = this.data.text;
            }
        }
        // Init data
        if (this.data &&
            this.data.notes &&
            Array.isArray(this.data.notes)) {
            try {
                for (var _b = tslib_1.__values(this.data.notes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var note = _c.value;
                    var category = '';
                    switch (note.category) {
                        case "subscription":
                            category = this.translateService.instant("platformNotes.categories.subscription");
                            break;
                        case "work-account":
                            category = this.translateService.instant("platformNotes.categories.work-account");
                            break;
                        case "technical-operational":
                            category = this.translateService.instant("platformNotes.categories.technical-operational");
                            break;
                        case "insertion":
                            category = this.translateService.instant("platformNotes.categories.insertion");
                            break;
                        case "mapping":
                            category = this.translateService.instant("platformNotes.categories.mapping");
                            break;
                        case "packaging":
                            category = this.translateService.instant("platformNotes.categories.packaging");
                            break;
                        case "tagnfc":
                            category = this.translateService.instant("platformNotes.categories.tagnfc");
                            break;
                        case "suppliers":
                            category = this.translateService.instant("platformNotes.categories.suppliers");
                            break;
                        case "other":
                            category = this.translateService.instant("platformNotes.categories.other");
                            break;
                    }
                    this.notes.push({
                        id: note._id,
                        text: category + " - " + note.title,
                        value: false,
                    });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // Stop loading dialog
        this.dialogIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    CompanyPlatformNotesDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    CompanyPlatformNotesDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close(data);
    };
    /**
     * Handle select signle property
     *
     * @since 1.0.0
     */
    CompanyPlatformNotesDialogComponent.prototype.onSelect = function (checked) {
        if (this.notes.some(function (el) { return el.value; })) {
            this.formBtnOptions.disabled = false;
        }
        else {
            this.formBtnOptions.disabled = true;
        }
    };
    /**
     * Handle select all properties
     *
     * @since 1.0.0
     */
    CompanyPlatformNotesDialogComponent.prototype.onSelectAll = function (checked) {
        this.selectAll = checked;
        if (!checked) {
            this.notes.forEach(function (property) {
                property["value"] = false;
            });
            this.formBtnOptions.disabled = true;
        }
        else if (checked) {
            this.notes.forEach(function (property) {
                property["value"] = true;
            });
            this.formBtnOptions.disabled = false;
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    CompanyPlatformNotesDialogComponent.prototype.onFormSubmit = function () {
        var notesSelected = [];
        if (this.notes && Array.isArray(this.notes)) {
            this.notes.forEach(function (item) {
                if (item.value) {
                    notesSelected.push(item.id);
                }
            });
        }
        this.onClose(notesSelected);
    };
    return CompanyPlatformNotesDialogComponent;
}());
export { CompanyPlatformNotesDialogComponent };
